// extracted by mini-css-extract-plugin
export var container = "_4o-0";
export var fallback = "_4o-5";
export var fallbackIcon = "_4o-6";
export var hidden = "_4o-2";
export var image = "_4o-3";
export var loaded = "_4o-4";
export var placeholder = "_4o-1";